<template>
  <div id="app">
    <!-- 路由内容显示区域 -->
    <router-view class="main-container"></router-view>
    <nav v-if="$route.meta.showNav" class="bottom-nav w3-bar w3-blue">
      <router-link to="/coinrecord" class="w3-bar-item w3-button">U记录</router-link>
      <router-link to="/gamerecord" class="w3-bar-item w3-button">游戏记录</router-link>
      <router-link to="/withdrawTX" class="w3-bar-item w3-button">提U记录</router-link>
    </nav>
  </div>
</template>

<style>
#app {
  position: relative;
  min-height: 100vh;
  /* 确保容器撑满视口高度 */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;

  @media (max-width: 767px) {
    font-size: small;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: medium;
  }

  @media (min-width: 1025px) {
    font-size: medium;
  }
}

.main-content {
  padding-bottom: 60px;
  /* 底部导航高度 + 边距 */
}

/* 激活的导航链接样式 */
.router-link-active {
  background-color: #003366 !important;
}

/* 固定底部导航 */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  /* 确保导航在最顶层 */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  /* 顶部阴影效果 */
}
</style>